const images = document.querySelectorAll('.our-mission-sec__image');
const items = document.querySelectorAll('.our-mission-sec__item');

if (images.length && items.length) {
  let activeIndex = 0;

  const prevArrows = document.querySelectorAll('.our-mission-sec .swiper-button-prev');
  const nextArrows = document.querySelectorAll('.our-mission-sec .swiper-button-next');

  const updateHeight = (index) => {
    const activeItem = items[index];

    const itemBody = activeItem.querySelector('.our-mission-sec__item-body');

    activeItem.classList.add('active');
    if (itemBody) {
      itemBody.style.maxHeight = `${itemBody.scrollHeight + 80}px`;
    }
  }

  const updateState = (index) => {
    items.forEach(it => {
      it.classList.remove('active');
      const body = it.querySelector('.our-mission-sec__item-body');
      if (body) body.style.maxHeight = null;
    });
    images.forEach(img => {
      img.classList.remove('active');
      img.style.display = 'none';
      img.style.opacity = 0;
    });

    const activeItem = items[index];
    const activeImage = images[index];

    updateHeight(index);

    activeImage.style.display = 'block';
    requestAnimationFrame(() => {
      activeImage.style.opacity = 1;
      activeImage.classList.add('active');
    });

    if (prevArrows.length) prevArrows.forEach((arrow) => arrow.classList.toggle('disabled', index === 0));
    if (nextArrows.length) nextArrows.forEach((arrow) => arrow.classList.toggle('disabled', index === items.length - 1));
  };

  updateState(activeIndex);

  items.forEach((item, i) => {
    const itemNav = item.querySelector('.our-mission-sec__item-nav');
    itemNav.addEventListener('click', () => {
      if (i === activeIndex) return;
      activeIndex = i;
      updateState(activeIndex);
    });
  });

  if (prevArrows.length) {
    prevArrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        if (activeIndex > 0) {
          activeIndex--;
          updateState(activeIndex);
        }
      });
    })
  }

  if (nextArrows.length) {
    nextArrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        if (activeIndex < items.length - 1) {
          activeIndex++;
          updateState(activeIndex);
        }
      });
    })
  }

  window.addEventListener('resize', () => {
    // updateState(activeIndex);
    updateHeight(activeIndex)
  });
}